import {useEffect, useMemo, useRef, useState} from 'react';
import {Table} from 'antd';
import {getAllInvoices} from "../../api/Api";
import {getColumnSearchProps} from "../widget/SearchProps";

export const BalancesDue = ({buyers, refresh, onRefresh, onApiFail, props}) => {
    const [invoice, setInvoice] = useState([]);

    useEffect(() => {
        getAllInvoices().then(r => {
            setInvoice(r.map(i => {
                return {
                    ...i,
                    key: i.id
                }
            }))
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [onApiFail, refresh])

    const balances = useMemo(() => {
        const buyerMap = {}
        buyers.forEach(b => {
            if (buyerMap[b.id] === undefined) {
                buyerMap[b.id] = b;
            }
        })

        // perform group by balances
        const userMap = {}
        invoice.forEach(i => {
            if (userMap[i.buyerId] === undefined) {
                userMap[i.buyerId] = {
                    buyerId: i.buyerId,
                    balanceDue: 0,
                    firstname: i.firstname,
                    lastname: i.lastname,
                    invoices: [],
                    key: i.buyerId,
                }
                if (buyerMap && buyerMap[i.buyerId]) {
                    userMap[i.buyerId].company = buyerMap[i.buyerId].company
                }
            }
            console.log(`subtotal ${i.subtotal} paid ${i.amountPaid}`);
            userMap[i.buyerId].balanceDue += (i.subtotal - i.amountPaid);
            userMap[i.buyerId].invoices.push(i);
        })

        console.log(JSON.stringify(userMap));
        return Object.values(userMap);
    }, [invoice, buyers])

    // for use with search props
    const searchInput = useRef(null);

    const columns = [
        {
            title: 'Name',
            dataIndex: 'firstname',
            key: 'firstname',
            render: (val, buyer, index) => {
                return `${buyer.firstname} ${buyer.lastname}`
            },
            ...getColumnSearchProps(`firstname`, searchInput),
            sorter: (a, b) => a.firstname.toLowerCase().localeCompare(b.firstname.toLowerCase()),
        },
        {
            title: 'Company',
            dataIndex: 'company',
            key: 'company',
            ...getColumnSearchProps(`company`, searchInput),
            sorter: (a, b) => a.company.toLowerCase().localeCompare(b.company.toLowerCase()),
        },
        {
            title: 'Balance Due',
            dataIndex: 'balanceDue',
            key: 'balanceDue',
            render: (val) => {
                return `$ ${val}`
            },
            sorter: (a, b) => a.balanceDue- b.balanceDue
        }
    ]

    return <Table dataSource={balances} columns={columns} />
}